// Module
var code = "<div class=\"ui-grid-cell-contents\" ng-bind=\"row.entity.RetriedByTransactionId | invEmpty\"></div>";
// Exports
module.exports = code;